<template>
  <div>
    <h5 class="info-text"> Let's start with the basic information about the programme</h5>
    <div class="row justify-content-center">

      <div class="col-sm-4">
        <fg-input required
                  type="text"
                  name="title"
                  label="Title"
                  v-model="model.title"
                  v-validate="modelValidations.title"
                  :error="getError('title')">
        </fg-input>
      </div>

      <div class="col-sm-4">
        <fg-input required
                  type="text"
                  name="description"
                  label="Description"
                  v-model="model.description"
                  v-validate="modelValidations.description"
                  :error="getError('description')">
        </fg-input>
      </div>

      <div class="col-sm-2">
        <fg-input
            type="number"
            required
            name="price"
            label="Price"
            v-validate="modelValidations.price"
            :error="getError('price')"
            v-model="model.price">
        </fg-input>
      </div>

      <div class="col-sm-2">
        <fg-input required
                  type="text"
                  name="venue"
                  label="Venue"
                  v-model="model.venue"
                  v-validate="modelValidations.venue"
                  :error="getError('venue')">
        </fg-input>
      </div>

      <div class="col-sm-3">
          <fg-input
              type="text"
              required
              name="department"
              label="Department"
              v-validate="modelValidations.department"
              :error="getError('department')"
              v-model="model.department">
              <el-select class="select-primary" placeholder="Select Department" v-model="model.department" clearable filterable>
                  <el-option v-for="(option, index) in departments" class="select-primary" :value="option" :label="option" :key="index">
                  </el-option>
              </el-select>
          </fg-input>
      </div>
      <div class="col-sm-3">
          <fg-input
              type="text"
              required
              name="type"
              label="Type"
              v-validate="modelValidations.type"
              :error="getError('type')"
              v-model="model.type">
              <el-select class="select-primary" placeholder="Select Type" v-model="model.type" clearable>
                  <el-option v-for="(option, index) in types" class="select-primary" :value="option" :label="option" :key="index">
                  </el-option>
              </el-select>
          </fg-input>
      </div>

      <div class="col-sm-3">
          <fg-input
              type="text"
              required
              name="eventType"
              label="Event Type"
              v-validate="modelValidations.eventType"
              :error="getError('eventType')"
              v-model="model.eventType">
              <el-select class="select-primary" placeholder="Select Event Type" v-model="model.eventType" clearable>
                  <el-option v-for="(option, index) in types" class="select-primary" :value="option" :label="option" :key="index">
                  </el-option>
              </el-select>
          </fg-input>
      </div>

      <div class="col-sm-3">
          <fg-input
              type="text"
              name="paper"
              label="Course"
              v-validate="modelValidations.paper"
              :error="getError('paper')"
              v-model="model.paper">
              <el-select class="select-primary" placeholder="Select Course" v-model="model.paper" filterable clearable value-key="slug">
                  <el-option v-for="(option, index) in papers" class="select-primary" :value="option.slug" :label="`${option.code} - ${option.title}`" :key="index">
                  </el-option>
              </el-select>
          </fg-input>
      </div>

      <div class="col-sm-3">
          <fg-input
              type="date"
              name="open_date"
              label="Open Date"
              v-validate="modelValidations.open_date"
              :error="getError('open_date')"
              v-model="model.open_date">
              <el-date-picker 
                  v-model="model.open_date" 
                  type="datetime" 
                  placeholder="Open Date">
              </el-date-picker>
          </fg-input>
      </div>

      <div class="col-sm-3">
          <fg-input
              type="date"
              name="close_date"
              label="Close Date"
              v-validate="modelValidations.close_date"
              :error="getError('close_date')"
              v-model="model.close_date">
              <el-date-picker 
                  v-model="model.close_date" 
                  type="datetime" 
                  placeholder="Close Date">
              </el-date-picker>
          </fg-input>
      </div>

      <div class="col-sm-3">
          <fg-input
              type="date"
              name="start_date"
              label="Start Date"
              v-validate="modelValidations.start_date"
              :error="getError('start_date')"
              v-model="model.start_date">
              <el-date-picker 
                  v-model="model.start_date" 
                  type="datetime" 
                  placeholder="Start Date">
              </el-date-picker>
          </fg-input>
      </div>

      <div class="col-sm-3">
          <fg-input
              type="date"
              name="end_date"
              label="End Date"
              v-validate="modelValidations.end_date"
              :error="getError('end_date')"
              v-model="model.end_date">
              <el-date-picker 
                  v-model="model.end_date" 
                  type="datetime" 
                  placeholder="End Date">
              </el-date-picker>
          </fg-input>
      </div>

      <div class="col-sm-4 d-flex justify-content-between">
        <fg-input
            type="text"
            required
            name="login"
            label="Auth ?"
            v-validate="modelValidations.login"
            :error="getError('login')"
            v-model="model.login">
            <n-switch v-model="model.login" on-text="True" off-text="False"></n-switch>
        </fg-input>
        <fg-input
            type="text"
            required
            name="visible"
            label="Visible ?"
            v-validate="modelValidations.visible"
            :error="getError('visible')"
            v-model="model.visible">
            <n-switch v-model="model.visible" on-text="True" off-text="False"></n-switch>
        </fg-input>
        <fg-input
            type="text"
            required
            name="pool"
            label="Pool ?"
            v-validate="modelValidations.pool"
            :error="getError('pool')"
            v-model="model.pool">
            <n-switch v-model="model.pool" on-text="True" off-text="False"></n-switch>
        </fg-input>
      </div>

      <div class="col-sm-2">
        <fg-input
            type="text"
            required
            name="max_seat"
            label="Max Registrations"
            v-validate="modelValidations.max_seat"
            :error="getError('max_seat')"
            v-model="model.seating.max_seat">
            <el-input-number v-model="model.seating.max_seat" size="medium" :min="1" :max="10000"></el-input-number>
        </fg-input>
      </div>

      <div class="col-sm-2">
        <fg-input
            type="text"
            required
            name="permitted_enrollments"
            label="Perm Enrolls"
            v-validate="modelValidations.permitted_enrollments"
            :error="getError('permitted_enrollments')"
            v-model="model.permitted_enrollments">
            <el-input-number v-model="model.permitted_enrollments" size="medium" :min="1" :max="10000"></el-input-number>
        </fg-input>
      </div>

      <div class="col-sm-2">
        <fg-input
            type="text"
            required
            name="min_participants"
            label="Min Participants"
            v-validate="modelValidations.min_participants"
            :error="getError('min_participants')"
            v-model="model.min_participants">
            <el-input-number v-model="model.min_participants" size="medium" :min="1" :max="10000"></el-input-number>
        </fg-input>
      </div>

      <div class="col-sm-2">
        <fg-input
            type="text"
            required
            name="max_participants"
            label="Max Participants"
            v-validate="modelValidations.max_participants"
            :error="getError('max_participants')"
            v-model="model.max_participants">
            <el-input-number v-model="model.max_participants" size="medium" :min="1" :max="10000"></el-input-number>
        </fg-input>
      </div>

      <div class="col-sm-4">
        <label>Others</label>
        <n-button v-if="model.login" type="primary" round block @click.native="openModal('batches')">Add Batches {{ ( model.batches && model.batches.length > 0) ? `(${model.batches.length})` : '' }}</n-button>
        <n-button type="primary" round block @click.native="openModal('forms')">Add Forms {{ ( model.form && model.form.length > 0) ? `(${model.form.length})` : '' }}</n-button>
        <n-button type="primary" round block @click.native="openModal('coordinators')">Add Coordinators {{ ( model.coordinators && model.coordinators.length > 0) ? `(${model.coordinators.length})` : '' }}</n-button>
      </div>
      <div class="col-sm-8">
        <label>Cover Image</label>
        <el-upload
            ref="imageUploader"
            class="avatar-uploader"
            name="image"
            list-type="text"
            accept="image/jpeg,image/png"
            :data="{path: 'tukio/programmes/'}"
            :action="uploadURL"
            :headers="headers"
            :show-file-list="true"
            :on-success="handleAvatarSuccess"
            :before-remove="handleRemove"
            :before-upload="beforeAvatarUpload">
            <div v-if="model.image" class="avatar" :style="`background-image: url(${model.image})`"></div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>

    </div>

    <modal :show.sync="modals.batches" headerClasses="justify-content-center" footerClasses="justify-content-center" type="large">
        <h4 slot="header" class="title title-up">Select Batches</h4>
        <div class="row">
            <div class="col-12">
                <el-transfer
                    filterable
                    :filter-method="filterMethod"
                    filter-placeholder="Batches"
                    v-model="model.batches"
                    :titles="['Available', 'Selected']"
                    :data="batches">
                </el-transfer> 
            </div>
        </div>
    </modal>

    <!-- <modal :show.sync="modals.forms" headerClasses="justify-content-center" footerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">Create Custom Form</h4>
        <div class="row">
            <div class="col-12">
                <CustomForm @on-submit="gotForm" :pool="model.pool" :login="model.login" :forms="model.form"></CustomForm>
            </div>
        </div>
    </modal> -->

    <el-drawer
      size="80%"
      direction="rtl"
      title="Create Custom Form"
      :z-index="9999999"
      :show-close="true"
      :append-to-body="true"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :visible.sync="modals.forms">
      <CustomForm @on-submit="gotForm" :pool="model.pool" :login="model.login" :forms="model.form" :label-assignment="model.type == 'group'"></CustomForm>
    </el-drawer>

    <!-- <modal :show.sync="modals.coordinators" headerClasses="justify-content-center" footerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">Add Coordinators Form</h4>
        <div class="row">
            <div class="col-12">
                <CoordinatorsForm @on-submit="gotCoordinators" v-if="programme" :cords="programme.coordinators"></CoordinatorsForm>
            </div>
        </div>
    </modal> -->

    <el-drawer
      size="80%"
      direction="rtl"
      title="Create Coordinators Form"
      :z-index="9999999"
      :show-close="true"
      :append-to-body="true"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :visible.sync="modals.coordinators">
      <CoordinatorsForm @on-submit="gotCoordinators" v-if="programme" :cords="programme.coordinators"></CoordinatorsForm>
    </el-drawer>

  </div>
</template>
<script>
import { Upload, Select, Option, DatePicker, Transfer, InputNumber, Drawer, MessageBox } from 'element-ui';
import { Switch, Modal, CustomForm, CoordinatorsForm } from "src/components";
import { mapGetters } from 'vuex';

export default {
  components: {
    [Upload.name]: Upload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Transfer.name]: Transfer,
    [DatePicker.name]: DatePicker,
    [InputNumber.name]: InputNumber,
    [Drawer.name]: Drawer,
    Modal,
    CustomForm,
    CoordinatorsForm
  },
  props: {
    scope: String,
    batches: Array,
    programme: {
      type: Object,
      default: null
    }
  },
  computed: {
        ...mapGetters({
            departments: 'getDepartments',
            types: 'getProgrammeTypes',
            papers: 'getPapers',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences',
        }),
        // transfer_data(){
        //     const data = [];
        //     if(this.batches)
        //         this.batches.forEach((batch, index) => {
        //             data.push({
        //                 label: batch,
        //                 key: index
        //             });
        //         });
        //     return data;
        // },
        headers(){
            this.authTokens['content-type'] = 'multipart/form-data'
            let {token, refreshtoken} = this.authTokens
            return {token, refreshtoken};
        },
        uploadURL(){
            return `${process.env.VUE_APP_BASE_URL}/tukio/upload`
        }
  },
  watch:{
    programme(programmeVal){
      if(programmeVal != null && this.scope == 'edit'){
        this.model = programmeVal

        // let batches = []
        // this.model.batches.forEach((batch, index) => {
        //     batches.push(this.batches.findIndex((item) => item == batch))
        // })
        // this.model.batches = batches
      }
    },
    // batches(batchesVal){
    //   let batches = []
    //   this.model.batches.forEach((batch, index) => {
    //       batches.push(batchesVal.findIndex((item) => item == batch))
    //   })
    //   this.model.batches = batches
    // }
  },
  mounted(){
    this.$store.dispatch('getDepartments');
    this.$store.dispatch('getProgrammeTypes');
    this.$store.dispatch('getPapers');
  },
  data() {
    return {
      model: {
        type: 'individual',
        login: false,
        batches: [],
        eventType: 'group',
        title: '',
        description: '',
        department: '',
        image: '',
        visible: false,
        pool: false,
        min_participants: 1,
        max_participants: 1,
        permitted_enrollments: 1,
        open_date: null,
        close_date: null,
        start_date: null,
        end_date: null,
        price: 0,
        venue: null,
        seating : {
          limited: false,
          current_seat: 0,
          max_seat: 500
        },
        form: [],
        events: [],
        paper: null
      },
      modelValidations: {
        type: {
          required: true,
        },
        login: {
          required: true,
        },
        eventType: {
          required: true,
        },
        title: {
          required: true,
        },
        venue: {
          required: true,
        },
        description: {
          required: true,
        },
        department: {
          required: true,
        },
        visible: {
          required: true,
        },
        pool: {
          required: true,
        },
        permitted_enrollments: {
          required: true,
        },
        open_date: {
          required: true,
        },
        close_date: {
          required: true,
        },
        start_date: {
          required: true,
        },
        end_date: {
          required: true,
        },
        price: {
          required: true,
        },
        max_seat: {
          required: true,
        },
        min_participants: {
          required: true,
        },
        max_participants: {
          required: true,
        },
        paper: {
          required: false
        }
      },
      modals: {
        batches: false,
        forms: false,
        coordinators: false
      },
    };
  },
  methods: {
    filterMethod(query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    },
    handleRemove(file, fileList){
      this.model.image = null
    },
    handlePreview(file) {
      this.model.image = URL.createObjectURL(file.raw);
    },
    openModal(name){
      this.modals[name] = true
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    gotForm(form){
      this.model.form = form
      this.modals.forms = false
    },
    gotCoordinators(coordinators){
      this.model.coordinators = coordinators
      this.modals.coordinators = false
    },
    validate() {
      return this.$validator.validateAll().then(isValid => {

        if(isValid){
          // let batches = []
          // this.model.batches.forEach((batch, index) => {
          //     batches.push(this.batches[batch])
          // })
          // this.model.batches = batches

          this.$refs.imageUploader.clearFiles();

          this.$emit('on-validated', isValid, this.model);
        }
        return true;
      });
    },
    handleAvatarSuccess(res, file) {
        this.model.image = res.data.image;
    },
    beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            this.$notify({
                message: `Cover picture size can not exceed 2MB!`,
                icon: 'fa fa-bell',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'danger'
            })
        }
        return isLt2M;
    },
    handleClose(done) {
      MessageBox.confirm('Are you sure you want to close this?')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    }
  }
};
</script>
<style lang="scss">
.el-transfer-panel__filter.el-input{
    width: 85%;
}

.el-input-number{
  display: block;
  width: 100%;
}


</style>
